import { makeStyles } from '@material-ui/core/styles'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import formatDate from 'src/utils/commonMethods/formatDate'
import {
  CLIENT_TYPE,
  CLIENT_TYPE_SMALL_CASE,
  INSURANCE_CATEGORIES,
  POLICY_STATUS_TYPES,
} from 'src/utils/constants/common'
import { Grid } from '@mui/material'
import {
  isCorporatePOC,
  isEBPolicy,
  isMotorInsurance,
} from 'src/utils/commonMethods'
import DefaultLogo from 'src/assets/PolicyDetails_Images/DefaultLogo.svg'
import DigitalizingBar from 'src/components/Individual/StatusBar/DigitalizingBar'
import InvalidDocumentBar from 'src/components/Individual/StatusBar/InvalidDocumentBar'
import documentDownload from 'src/utils/commonMethods/documentDownload'
import keycloak from 'src/utils/commonMethods/keycloak'
import { invokeAllTypesSXP } from 'src/services/individualService'
import policyDuration from 'src/assets/PolicyTile_Images/policyDuration.svg'
import RenewNow from 'src/assets/PolicyTile_Images/RenewNow.svg'
import Modal from 'src/components/common/Modal'
import { useState } from 'react'
import RenewModal from 'src/components/common/RenewPolicy/RenewModal'
import { INSURANCE_NAMES } from 'src/utils/constants/InsuranceNames'
import { getBuyType } from 'src/utils/commonMethods/buyPolicy'
import { useDispatch } from 'react-redux'
import { updateBuyPolicyTitle } from 'src/actions'
import { useHistory } from 'react-router-dom'
import RenewedPolicy from 'src/assets/PolicyTile_Images/RenewedPolicy.svg'
import TrackRenewedPolicyForm from 'src/components/common/RenewPolicy/TrackRenewedPolicyForm'

const ViewPolicyTile = ({
  policyData,
  handlePolicySelect,
  userInfo,
  path,
  policies,
  policyType,
  clientType,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [showRenewalModal, setShowRenewalModal] = useState(false)
  const [showTrackForm, setShowTrackForm] = useState(false)
  const [isTracking, setIsTracking] = useState(false)
  const [trackClick, setTrackClick] = useState(false)
  const handlePolicyClick = () => {
    handlePolicySelect()
  }

  const role = userInfo?.userInfo?.userData?.roles

  const invokeSxpUpload = (policy, type) => {
    const sxpUploadBody = {
      state: {
        clientId:
          userInfo?.userInfo?.userData?.clientId == null
            ? userInfo?.userName
            : userInfo?.userInfo?.userData?.clientId,
        clientType: userInfo?.userInfo?.userData?.policyHolderType,
        createdBy: userInfo?.userName,
        updatedBy: userInfo?.userName,
        policy: policy,
        email: userInfo?.userInfo?.userData?.emailId,
        url: path,
        policyType: policyType,
        token: keycloak?.token,
        roles: userInfo?.userInfo?.userData?.roles,
        clientTypeUrl:
          userInfo?.userInfo?.userData?.policyHolderType ===
          CLIENT_TYPE?.CORPORATE
            ? CLIENT_TYPE_SMALL_CASE?.CORPORATE
            : CLIENT_TYPE_SMALL_CASE?.INDIVIDUAL,
      },
      userId: userInfo?.userName,
    }
    invokeAllTypesSXP(sxpUploadBody, userInfo?.userName, type)
  }

  const showProgressBar = () => {
    const statusTypes = [
      POLICY_STATUS_TYPES?.digitalizing,
      POLICY_STATUS_TYPES?.verificationPending,
      POLICY_STATUS_TYPES?.documentRequired,
      POLICY_STATUS_TYPES?.invalidDocument,
      POLICY_STATUS_TYPES?.renewalUnderDigitalizing,
    ]
    return statusTypes?.includes(policyData?.status)
  }

  const getStatusBarComponents = () => {
    switch (policyData?.status) {
      case POLICY_STATUS_TYPES?.digitalizing:
      case POLICY_STATUS_TYPES?.verificationPending:
        return (
          <DigitalizingBar
            id='digitalizingBar'
            documentDownload={(event) => {
              event?.stopPropagation()
              handleDocumentDownload(
                policyData?.policyDocument,
                policyData?.policyDocumentURL
              )
            }}
            status={policyData?.status}
          />
        )
      case POLICY_STATUS_TYPES?.renewalUnderDigitalizing:
        return (
          <DigitalizingBar
            id='digitalizingBar'
            documentDownload={(event) => {
              event?.stopPropagation()
              handleDocumentDownload(
                policyData?.policyDocument,
                policyData?.policyDocumentURL
              )
            }}
            status={policyData?.status}
          />
        )
      case POLICY_STATUS_TYPES?.documentRequired:
      case POLICY_STATUS_TYPES?.invalidDocument:
        return (
          <InvalidDocumentBar
            id='invalidDocumentBar'
            documentDownload={(event) => {
              event?.stopPropagation()
              handleDocumentDownload(
                policyData?.policyDocument,
                policyData?.policyDocumentURL
              )
            }}
            status={policyData?.status}
            policyDetails={policyData}
            invokeSxp={(event, policy, type) => {
              event?.stopPropagation()
              invokeSxpUpload(policy, type)
            }}
          />
        )
      default:
        return null
    }
  }

  const handleDocumentDownload = async (document, documentURL) => {
    documentDownload(document ? document : [], documentURL)
  }

  const handleClick = () => {
    const insuranceType =
      policyData?.insuranceType === INSURANCE_NAMES?.MOTOR_INSURANCE
        ? policyData?.productSubType
        : policyData?.insuranceType
    const url = getBuyType(insuranceType)

    const insuranceName = policyData?.productSubType
      ? policyData?.productSubType
      : policyData?.insuranceType

    if (
      url !== INSURANCE_CATEGORIES?.HEALTH ||
      url !== INSURANCE_CATEGORIES?.BIKE ||
      url !== INSURANCE_CATEGORIES?.MOTOR
    ) {
      dispatch(updateBuyPolicyTitle(insuranceName))
      history.push('/individual/dashboard/buyPolicy/life')
    } else {
      history.push(`/individual/dashboard/buyPolicy/${url}`)
    }
  }

  const handleUploadRenewalModal = () => {
    setShowRenewalModal(true)
  }

  const closeRenewalModal = () => {
    setShowRenewalModal(false)
  }

  const handleTrackClick = (isTrack) => {
    setShowTrackForm(true)
    setIsTracking(isTrack)
    setTrackClick(isTrack)
  }

  const closeTrackModalForm = () => {
    setShowTrackForm(false)
  }

  return (
    <>
      {showRenewalModal ? (
        <Modal
          id='modal'
          bgcolor={'#FFF'}
          ordered={showRenewalModal}
          width={'30%'}
          left={'32%'}
          top={'30%'}
          borderRadius={'10px'}
          modelClosed={closeRenewalModal}
        >
          <RenewModal
            closeRenewModal={closeRenewalModal}
            policyDetails={policyData}
            handleClick={handleClick}
          />
        </Modal>
      ) : null}
      {showTrackForm ? (
        <Modal
          id='modal'
          bgcolor={'#FFF'}
          ordered={showTrackForm}
          width={'90%'}
          left={'5%'}
          top={'7%'}
          borderRadius={'10px'}
          modelClosed={closeTrackModalForm}
        >
          <TrackRenewedPolicyForm
            closeModal={closeTrackModalForm}
            policyData={policyData}
            isTracking={isTracking}
            trackClick={trackClick}
            clientType={clientType}
          />
        </Modal>
      ) : null}
      <div
        className={classes.mainContainer}
        onClick={handlePolicyClick}
        id='policyContainer'
      >
        {isMotorInsurance(policyData?.insuranceType) && (
          <div className={classes.policyMotorDiv}>
            <div>
              <span className={classes.subText}>Registration No:&nbsp;</span>
              <span className={classes.valueTextMotor}>
                {policyData?.otherInformation?.vehicleNumber ?? '-'}
              </span>
            </div>
            <div>
              <span className={classes.subText}>Model:&nbsp;</span>
              <span className={classes.valueTextMotor}>
                {policyData?.otherInformation?.vehicleMakeModel ?? '-'}
              </span>
            </div>
            <div>
              <span className={classes.subText}>Type:&nbsp;</span>
              <span className={classes.valueTextMotor}>
                {policyData?.productSubType ?? '-'}
              </span>
            </div>
          </div>
        )}
        <Grid
          container
          spacing={2}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Grid item xs={12} sm={2} md={2} lg={1} xl={2}>
            {policyData?.provider?.image ? (
              <img
                src={policyData?.provider?.image}
                alt='Logo'
                className={classes.providerImage}
              />
            ) : (
              <img
                src={DefaultLogo}
                alt='defaultLogo'
                className={classes.defaultProviderImage}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={5}
            md={5}
            lg={3}
            xl={2}
            justifyContent={'center'}
          >
            <div className={classes.providersHeading}>
              <div className={classes.text}>
                <span>{policyData?.insuranceType}</span>
              </div>
              {!isMotorInsurance(policyData?.insuranceType)
                ? policyData?.productSubType && (
                    <div className={classes.valueTextMotor}>
                      <span>{policyData?.productSubType ?? '-'}</span>
                    </div>
                  )
                : null}
              <div className={classes.policyNumberText}>
                <span>Policy No: {policyData?.policyNumber ?? '-'}</span>
              </div>
            </div>
          </Grid>
          {showProgressBar() ? (
            <Grid item xs={12} sm={5} md={5} lg={8} xl={8}>
              {getStatusBarComponents()}
            </Grid>
          ) : (
            <>
              <Grid item xs={12} sm={5} md={5} lg={2} xl={2}>
                <div className={classes.contentText}>
                  {policyData?.status === POLICY_STATUS_TYPES?.expired && (
                    <span className={classes.expired}>Expired</span>
                  )}
                  {policyData?.status === POLICY_STATUS_TYPES?.renewed && (
                    <span className={classes.expired}>Renewed</span>
                  )}
                  <div className={classes.dateImageContent}>
                    <div>
                      <img
                        src={policyDuration}
                        alt='datePicker'
                        className={classes.datePickerImage}
                      />
                    </div>
                    <div className={classes.dateContent}>
                      <div>
                        <span className={classes.date}>
                          {formatDate(policyData?.issuedOn)}&nbsp;
                        </span>
                      </div>
                      <div className={classes.date}>
                        <span className={classes.date}>
                          {formatDate(policyData?.expiresOn)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>

              {isMotorInsurance(policyData?.insuranceType) ? (
                <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
                  <div className={classes.premiumPaid}>
                    <span className={classes.textContent}>IDV</span>
                    <span className={classes.value}>
                      {formatToINR(
                        policyData?.otherInformation?.vehicleIdv ?? '-'
                      )}
                    </span>
                  </div>
                </Grid>
              ) : (
                <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
                  <div className={classes.premiumPaid}>
                    <span className={classes.textContent}>Sum Insured</span>
                    <span className={classes.value}>
                      {formatToINR(policyData?.sumAssured?.text ?? '-')}
                    </span>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
                <div className={classes.premiumPaid}>
                  <span className={classes.textContent}>Premium Paid </span>
                  <span className={classes.value}>
                    {formatToINR(policyData?.premiumAmount?.text)}
                  </span>
                </div>
              </Grid>
              <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
                <div className={classes.premiumPaid}>
                  <span className={classes.textContent}>Claims</span>
                  <span className={classes.value}>
                    {formatToINR(policyData?.claimAmount?.text)}
                  </span>
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </div>
      <div className={classes.renewContainer}>
        {isCorporatePOC(role) && (
          <div>
            {(policyData?.status === POLICY_STATUS_TYPES?.expired ||
              (policyData?.isNearToExpire &&
                policyData?.status === POLICY_STATUS_TYPES?.active)) && (
              <div className={classes.renewedPolicy}>
                <img
                  src={RenewNow}
                  alt='renewNowButton'
                  className={classes.renewNowButton}
                  onClick={() => handleUploadRenewalModal(false)}
                />
              </div>
            )}
          </div>
        )}

        {isCorporatePOC(role) && (
          <div>
            {policyData?.status === POLICY_STATUS_TYPES?.underRenewal && (
              <div className={classes.renewedPolicyContainer}>
                <img
                  src={RenewedPolicy}
                  alt='renewedPolicyButton'
                  className={classes.renewedPolicyButton}
                />
              </div>
            )}
          </div>
        )}
      </div>

      <div className={classes.belowTileMainContainer}>
        <div className={classes.belowTile}>
          <div className={classes.belowTileDetails}>
            <span className={classes.belowTileTextHead}>Location : </span>
            <span className={classes.belowTileText}>
              {policyData?.otherInformation?.city ?? '-'}
            </span>
          </div>
          {isEBPolicy(policyData?.insuranceType) ? (
            <div className={classes.belowTileDetails}>
              <span className={classes.belowTileTextHead}>Cover Range : </span>
              <span className={classes.belowTileText}>
                {policyData?.coverRange ?? '-'}
              </span>
            </div>
          ) : null}

          {isEBPolicy(policyData?.insuranceType) ? (
            <div className={classes.belowTileDetails}>
              <span className={classes.belowTileTextHead}>
                Total No of Employee :
              </span>
              <span className={classes.belowTileText}>
                {policyData?.totalNoOfEmployees ?? '-'}
              </span>
            </div>
          ) : null}
          {isCorporatePOC(role) && policies?.length > 1 && (
            <div>
              {policyData?.status === POLICY_STATUS_TYPES?.renewed && (
                <div className={classes.trackTile}>
                  <span
                    className={classes.trackTileTextHead}
                    onClick={() => handleTrackClick(true)}
                  >
                    TRACK
                  </span>
                </div>
              )}
            </div>
          )}
          {isCorporatePOC(role) && policies?.length > 1 && (
            <div>
              {policyData?.status === POLICY_STATUS_TYPES?.active &&
                policyData?.oldPolicyId && (
                  <div className={classes.trackTile}>
                    <span
                      className={classes.trackTileTextHead}
                      onClick={() => handleTrackClick(true)}
                    >
                      TRACK
                    </span>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}
export default ViewPolicyTile
const useStyles = makeStyles({
  mainContainer: {
    justifyContent: 'flex-start',
    padding: '10px',
    borderRadius: '10px',
    boxShadow: '0px 5px 5px 0px rgba(212, 202, 206, 1)',
    backgroundColor: '#FFFFFF',
    flexWrap: 'wrap',
    alignItems: 'center',
    '&:hover': {
      transform: 'translateX(0px) scale(1.1)',
      boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer',
      border: '1px solid #B92250',
      '& $providersHeading $text': {
        color: '#B92250 !important',
        textDecoration: 'underline !important',
      },
    },
  },
  providersHeading: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '10px',
  },
  contentText: {
    display: 'flex',
    gap: '5px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  premiumPaid: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3px',
  },
  dateImageContent: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
  },
  text: {
    fontSize: '15px',
    fontWeight: '600',
    color: '#000000',
    lineHeight: '18px',
  },
  subText: {
    fontSize: '12px',
    color: 'rgba(26, 26, 26, 0.6)',
    lineHeight: '20px',
  },
  providersContent: {
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
    flexGrow: '1',
    justifyContent: 'flex-end',
  },
  dateContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    flexWrap: 'wrap',
    justifyContent: 'spaceBetween',
  },
  date: {
    fontSize: '13px',
    color: '#333333',
  },
  dateText: {
    fontSize: '13px',
    color: '#EF6060',
  },
  textContent: {
    fontSize: '12px',
    color: 'rgba(51, 51, 51, 0.5)',
  },
  value: {
    fontSize: '15px',
    fontWeight: '600',
    textAlign: 'center',
  },
  providerImage: {
    width: '48px',
    padding: '5px',
  },
  providersImage: {
    paddingRight: '10px',
  },
  datePickerImage: {
    width: '16px',
    height: '35px',
  },
  expired: {
    fontSize: '9px',
    border: '1px solid rgba(239, 96, 96, 1)',
    borderRadius: '64px',
    color: 'rgba(255, 255, 255, 1)',
    lineHeight: '11px',
    background: 'rgba(239, 96, 96, 1)',
    textTransform: 'uppercase',
    padding: '3px',
  },
  expiredText: {
    padding: '0px 0px 0px 22px',
    textAlign: 'center',
  },
  belowTile: {
    display: 'flex',
  },
  belowTileDetails: {
    width: '100%',
    display: 'flex',
  },
  belowTileText: {
    color: '#61404E',
    padding: '10px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '14px',
    letterSpacing: '0em',
    width: '60%',
  },
  belowTileTextHead: {
    color: '#61404E',
    padding: '10px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '14px',
    letterSpacing: '0em',
    width: '40%',
  },
  belowTileBuyPolicyImage: {
    textAlign: 'center',
  },
  defaultProviderImage: {
    width: '28px',
    height: '35px',
    padding: '5px',
  },
  policyMotorDiv: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0px 8px',
    paddingBottom: '5px',
    marginBottom: '10px',
    borderBottom: '0.5px solid #E4E4E4',
  },
  valueTextMotor: {
    fontSize: '12px',
    color: '#1A1A1A',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
  },
  policyNumberText: {
    fontSize: '12px',
    color: 'rgba(26, 26, 26, 0.6)',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    paddingTop: '4px',
  },
  policyIdText: {
    fontSize: '12px',
    color: 'rgba(26, 26, 26, 0.6)',
    lineHeight: '20px',
    whiteSpace: 'nowrap',
    marginTop: '-4px',
  },
  belowTileMainContainer: {
    // marginTop: '-5px',
  },
  coverRange: {
    display: 'flex',
    alignItems: 'center',
  },
  totalNoOfEmployee: {
    display: 'flex',
    alignItems: 'center',
  },
  renewContainer: {},
  renewedPolicyContainer: {
    padding: '0px 5px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  renewedPolicyButton: {
    width: '250px',
  },
  renewedPolicy: {
    padding: '0px 5px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  renewedPolicyContent: {
    marginTop: '-15px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  renewNowButton: {
    width: '100px',
  },
  trackTileTextHead: {
    color: '#B92250',
    padding: '10px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '14px',
    letterSpacing: '0em',
    textDecoration: 'underline',
  },
  trackTile: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
  },
})
